import { ColorSwatch, IconImage } from './FilterCustomisations'

export function FilterInputCheckbox({ values, onFilter, name }) {
  return values.map((item) => {
    return (
      <div className="flex items-center gap-2 w-full h-fit mb-6 last:mb-0" key={item.value}>
        <input
          id={item.value}
          type="checkbox"
          name={name}
          checked={item.checked}
          disabled={item.disabled}
          onClick={() => onFilter(item.value)}
          className="field-checkbox peer disabled:opacity-50"
        />
        {item.color && <ColorSwatch color={item.color} />}
        {item.icon && <IconImage iconObject={item.icon} />}
        <label
          for={item.value}
          className="paragraph-sm text-neturals-secondary-grey peer-disabled:opacity-50"
        >
          {item.label}
        </label>
        {!item.count ? null : <p className="paragraph-sm text-neutrals-secondary-grey peer-disabled:opacity-50">({item.count})</p>}
      </div>
    )
  })
}
